/**
 * `localStorage` o'rami — ilovadagi BIRINCHI persistence qatlami (tema tanlovi va sidebar
 * holati shu orqali saqlanadi).
 *
 * Nega har amal try/catch bilan o'ralgan: panel Telegram Mini App webview'ida ham ochiladi,
 * u yerda `localStorage` cheklangan yoki butunlay bloklangan bo'lishi mumkin (sandbox,
 * private rejim). Bunday holatda tashlash o'rniga jimgina degrade qilamiz — o'qishda `null`,
 * yozishda no-op (holat shu sessiya davomida ishlaydi, faqat saqlanmaydi).
 */
export function readPref(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writePref(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Storage yo'q/bloklangan — jimgina o'tkazib yuboramiz.
  }
}
